const DoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
    <path
      fill="#4CAF50"
      d="M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0Zm-4.466-3.41a.844.844 0 0 0-1.216.026l-3.906 4.978-2.355-2.355a.844.844 0 1 0-1.193 1.193l2.977 2.977a.844.844 0 0 0 1.214-.023l4.491-5.614a.844.844 0 0 0-.012-1.181Z"
    />
  </svg>
);
export default DoneIcon;
